import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FormlyModule } from "@ngx-formly/core";

import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ToolBarModule } from "@progress/kendo-angular-toolbar";

import { FormlyKendoModule } from "@formly/kendo";
import { KendoEditFormComponent } from "./edit-form.component";


@NgModule({
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
        ButtonsModule, InputsModule, DialogModule, ToolBarModule,
        FormlyModule, FormlyKendoModule
    ],
    exports: [
        KendoEditFormComponent,
    ],
    declarations: [
        KendoEditFormComponent,
    ]
})
export class KendoEditFormModule { }
